export const isEdgeEnvironment = () => {
  const { hostname } = window.location;
  return hostname === 'localhost' || hostname === 'edge.pertento.ai';
};

export const useIsEdgeEnvironment = () => isEdgeEnvironment();
